import React from 'react';
import css from './AdminPageFlipAndWin.css';
import { Button } from '../../components';
import classNames from 'classnames';

export default ({ allCards, restCards, latestCards, noInStock, countryType, setCountryType }) => {
    const filterBadges = [
        {
            type: 'all',
            cards: allCards,
            label: 'Alle',
        },
        {
            type: 'rest',
            cards: restCards,
            label: 'Sichtbar',
        },
        {
            type: 'latest',
            cards: latestCards,
            label: 'Abgelaufen',
        },
        {
            type: 'noInStock',
            cards: noInStock,
            label: 'Vergeben',
        },
    ];
    return (
        <section className={css.statesNavBar}>
            {filterBadges.map(({ type, cards, label }, index) => (
                <Button
                    key={index}
                    type="button"
                    onClick={() => setCountryType(type)}
                    className={classNames(css.filterBadge, {
                        [css.selected]: type === countryType,
                    })}
                >
                    {label} ({cards.length})
                </Button>
            ))}
        </section>
    );
};
